import { render, staticRenderFns } from "./contracts-list.vue?vue&type=template&id=16204ec3&scoped=true&"
import script from "./contracts-list.vue?vue&type=script&lang=js&"
export * from "./contracts-list.vue?vue&type=script&lang=js&"
import style0 from "./contracts-list.vue?vue&type=style&index=0&id=16204ec3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16204ec3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16204ec3')) {
      api.createRecord('16204ec3', component.options)
    } else {
      api.reload('16204ec3', component.options)
    }
    module.hot.accept("./contracts-list.vue?vue&type=template&id=16204ec3&scoped=true&", function () {
      api.rerender('16204ec3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/fl44-contracts/contracts-list.vue"
export default component.exports